function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import Log from '@deephaven/log';
import MaskedInput from "./MaskedInput.js";
import { getNextSegmentValue } from "./DateInputUtils.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('DateInput');
var DATE_PATTERN = '[12][0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])';
var EXAMPLES = ['2000-01-01', '2022-12-31'];
var DATE_FORMAT = 'YYYY-MM-DD';
var DateInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? () => undefined : _props$onChange,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
    _props$onFocus = props.onFocus,
    onFocus = _props$onFocus === void 0 ? () => undefined : _props$onFocus,
    _props$onBlur = props.onBlur,
    onBlur = _props$onBlur === void 0 ? () => undefined : _props$onBlur,
    dataTestId = props['data-testid'];
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selection = _useState4[0],
    setSelection = _useState4[1];
  var handleChange = useCallback(newValue => {
    log.debug('handleChange', newValue);
    setValue(newValue);
    onChange(newValue);
  }, [onChange]);
  return /*#__PURE__*/_jsx("div", {
    className: "d-flex flex-row align-items-center",
    children: /*#__PURE__*/_jsx(MaskedInput, {
      ref: ref,
      className: classNames(className),
      example: EXAMPLES,
      getNextSegmentValue: getNextSegmentValue,
      onChange: handleChange,
      onSelect: setSelection,
      pattern: DATE_PATTERN,
      placeholder: DATE_FORMAT,
      selection: selection,
      value: value,
      onFocus: onFocus,
      onBlur: onBlur,
      "data-testid": dataTestId
    })
  });
});
DateInput.displayName = 'DateInput';
export default DateInput;
//# sourceMappingURL=DateInput.js.map